"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubItemsFieldValueGetter = void 0;
const safe_field_value_1 = require("../safe-field-value");
const get_value_1 = require("./get-value");
const sub_items_1 = require("../type-checking/sub-items");
class SubItemsFieldValueGetter extends safe_field_value_1.BaseFieldValueGetter {
    constructor() {
        super(...arguments);
        this.isValidFieldValue = (fieldValue) => {
            return (0, sub_items_1.isSubItemFieldValue)(fieldValue);
        };
        this.getEmptyValue = () => (0, get_value_1.getSubItemsEmptyValue)();
    }
}
exports.SubItemsFieldValueGetter = SubItemsFieldValueGetter;
